import React from 'react';
import { Snackbar as MuiSnackbar, Alert as MuiAlert, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const Snackbar = ({ open, onClose, type = 'error', message, duration = 0 }) => {
  if (!message) return null;

  let bgColor, textColor, borderColor, iconColor;
  switch (type) {
    case 'error':
      bgColor = (theme) => theme.palette['error'].light;
      textColor = (theme) => theme.palette['error'].main;
      borderColor = (theme) => theme.palette['error'].dark;
      iconColor = (theme) => theme.palette['error'].main;
      break;
    case 'success':
      bgColor = (theme) => theme.palette['success'].light;
      textColor = (theme) => theme.palette['success'].main;
      borderColor = (theme) => theme.palette['success'].dark;
      iconColor = (theme) => theme.palette['success'].main;
      break;
    case 'warning':
      bgColor = 'rgba(255, 244, 229, 0.9)';
      textColor = '#ed6c02'; 
      borderColor = '#ed6c02'; 
      iconColor = '#ed6c02'; 
      break;
    case 'info':
      bgColor = 'rgba(232, 244, 253, 0.9)'; 
      textColor = '#0288d1'; 
      borderColor = '#0288d1';
      iconColor = '#0288d1';
      break;
    default:
      bgColor = 'rgba(245, 245, 245, 0.9)';
      textColor = '#616161';
      borderColor = '#bdbdbd';
      iconColor = '#616161';
  }

  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <MuiAlert
        severity={type}
        sx={{
          fontSize: '1rem',
          fontWeight: '500',
          borderRadius: '10px',
          textAlign: 'left',
          display: 'flex',
          alignItems: 'center',
          minWidth: '350px',
          padding: '1rem',
          backgroundColor: bgColor,
          color: textColor,
          // border: `1px solid ${borderColor}`,
          '& .MuiAlert-icon': {
            color: iconColor,
          },
        }}
        action={
          <IconButton size="small" onClick={onClose} sx={{ color: iconColor }}>
            <CloseIcon fontSize="small"/>
          </IconButton>
        }
      >
        {message}
      </MuiAlert>
    </MuiSnackbar>
  );
};

export default Snackbar;
